/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled    from 'styled-components';
import { Media } from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const  StyledAnimatedScrollDownHybridPage = styled.div`
  display: none;
  ${Media.Tablet`
    display: block;
    position: absolute;
    bottom: 40px;
    right: 50%;
    transform: translateX(-50%);
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledAnimatedScrollDownHybridPage/index.js